<template>
    <div class="MemberInfo mx-auto my-2">
        <Nav></Nav>
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/images/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        <!-- 頭貼 -->
        <div class="d-flex mb-2">
            <img class="userPhoto mx-auto" :src="profile.pictureUrl" v-if="profile.pictureUrl"/>
        </div>
        <!-- 會員資料 -->
        <div class="Form px-3">
            <div class="d-flex">
                <span class="subtitle">會員編號：</span>
                <span class="info">{{DeweyUserId}}</span>
            </div>
            <div class="d-flex">
                <span class="subtitle">姓名：</span>
                <span class="info">{{UserData.name}}</span>
            </div>
            <div class="d-flex">
                <span class="subtitle">Email：</span>
                <span class="info">{{UserData.email}}</span>
            </div>
            <div class="d-flex">
                <span class="subtitle">電話：</span>
                <span class="info">{{UserData.phone}}</span>
            </div>
            <div class="d-flex">
                <span class="subtitle">性別：</span>
                <span class="info">{{ShowGender(UserData.gender)}}</span>
            </div>
            <div class="d-flex">
                <span class="subtitle">最想要：</span>
                <span class="info">{{UserData.service}}</span>
            </div>
            <div class="d-flex">
                <span class="subtitle">最想去的國家：</span>
                <span class="info">{{UserData.country}}</span>
            </div>
            <div class="d-flex">
                <span class="subtitle">諮詢辦公室：</span>
                <span class="info">{{UserData.office}}</span>
            </div>
            <div class="d-flex">
                <span class="subtitle">專屬顧問：</span>
                <span class="info">{{UserData.consultant}}</span>
            </div>

        </div>


        <MemberButtons></MemberButtons>
    </div>
</template>

<script>
import Nav from '@/components/Nav'
import MemberButtons from '@/components/LineComponents/MemberButtons'
import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'
import jsbarcode from 'jsbarcode'


export default {
    name: 'MemberInfo',
    components:{
        Nav,MemberButtons
    },
    data () {
        return {
            Token:'',
            UserData:{},
            userId:'',
            profile:null,
            showLoading:'',
            DeweyUserId:'',

        }
    },
    mounted(){
        
    },
    methods:{
        GetUserData(){
            this.showLoading = true;

            //登入驗證-輸入email及密碼
            const api =`${process.env.APIPATH}/api/Member/GetUserData`;
            const inputdata = {
                "userId":this.userId,
            };

            axios.post(api, inputdata)
                .then((response) => {
                    if(response.data.isSuccess){ 
                        this.showLoading = false;

                        this.UserData = response.data.userData;
                        console.log(this.UserData)
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
        ShowGender(type){
            
            if(type == 1){
                return '男';
            }else if(type == 2){
                return '女';
            }else{
                return '';
            }
        },
    },
    created(){
        this.userId=JSON.parse(sessionStorage.getItem('UserData')).userId;
        this.profile = JSON.parse(sessionStorage.getItem('profile'))
        this.DeweyUserId = JSON.parse(sessionStorage.getItem('UserData')).deweyUserId;
        this.GetUserData();
    },
}
</script>




// WEBPACK FOOTER //
// src/components/line/MemberInfo.vue